import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[raComponentHost]'
})
export class ComponentHostDirective {
	constructor(public viewContainerRef: ViewContainerRef) { }
}
